export const STORAGE_KEYS = {
  DEVICE_INFO: "ss:device:info",
  ACCESS_TOKEN: "ss:access:token",
  PLAYBACK_STREAM_ID: "ss:stream:id",
  PLAYBACK_CONFIG: "ss:playback:config",
  CAMERA_STREAM_DETAILS: "ss:camera:stream:details",
  USER_DATA: "ss:user:data",
}

// This function is used when we want to retrieve an item from local storage. It does not parse the data before returning it.
export const getLocalStorageItem = (item) => {
  return localStorage.getItem(item)
}

// This function is used when we want to store an object or array in local storage. It stringifies the data before storing it.
export const parseLocalStorageItem = (item) => {
  return JSON.parse(localStorage.getItem(item) || "null")
}

// This function is used when we want to store a string or primitive value in local storage. It does not stringify the data before storing it.
export const setLocalStorageItem = (item, data) => {
  localStorage.setItem(item, JSON.stringify(data))
}

// This function is used when we want to store a string or primitive value in local storage without stringifying it.
export const setLocalStoragewithoutStringify = (item, data) => {
  localStorage.setItem(item, data)
}

// This function is used when we want to clear all items from local storage.
export const clearLocalStorage = () => {
  localStorage.clear()
}

// This function is used when we want to remove an item from local storage.
export const removeLocalStorageItem = (item) => {
  localStorage.removeItem(item)
}
